export const encodeString = (str) => {
  let strArray = str.split("");
  return strArray.reduce((encodedStr, char, index) => {
    if (index % 2 === 0) {
      encodedStr += char;
    } else {
      encodedStr = char + encodedStr;
    }
    return encodedStr;
  }, "");
};

export const decodeString = (str) => {
  let strArray = str.split("");
  let splitPoint = strArray.length / 2;
  let splitA = strArray.slice(0, splitPoint);
  let splitB = strArray.slice(splitPoint, strArray.length);
  return splitB.reduce((decodedStr, char, index) => {
    decodedStr += char + splitA[splitA.length - index - 1];
    return decodedStr;
  }, "");
};
